<template>
  <div v-if="shouldShowBar" class="intercom-bottom-bar" @click="onClick">
    <div class="bar-content">
      <div class="trailing-group">
        <img class="chat-icon" :src="require('@/assets/icons/intercom_empty_invert.svg')" alt="" />
        <span class="label ri-font-18 ri-font-weight-bold">שיחה עם צוות התמיכה</span>
      </div>
      <div class="leading-group">
        <svg class="chevron" width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <div v-if="unreadMessages > 0" class="unread-badge ri-font-16 ri-font-weight-bold">{{ unreadMessages }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Segment from '@/Segment';
import Intercom from '@/Intercom';

export default {
  name: 'IntercomBottomBar',
  computed: {
    ...mapState('intercom', ['unreadMessages']),
    ...mapGetters('intercom', ['shouldShowBar']),
  },
  methods: {
    onClick() {
      Segment.trackUserInteraction('IntercomBottomBar_Clicked');
      Intercom.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@riseupil/base-ui/src/scss/riseup-colors';
@import '~@riseupil/base-ui/src/scss/riseup-z-index';

$bar-text-color: #FDFDFD;

.intercom-bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: $sticky-cta;
  display: flex;
  justify-content: center;
  cursor: pointer;
  direction: rtl;

  .bar-content {
    width: 100%;
    height: 62px;
    background-color: $riseup_yellow;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 27px 0 15px;
    box-sizing: border-box;
  }

  .trailing-group {
    display: flex;
    align-items: center;
    gap: 12px;

    .chat-icon {
      width: 22px;
      height: 22px;
      display: block;
    }

    .label {
      color: $bar-text-color;
      line-height: 24px;
    }
  }

  .leading-group {
    direction: ltr;
    display: flex;
    align-items: center;
    gap: 3px;

    .chevron {
      color: $riseup_black;
      display: block;
    }

    .unread-badge {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background-color: $riseup_danger_red;
      color: $bar-text-color;
      line-height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
  }
}
</style>
